// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"deba6857","115":"9110be99","122":"373c0268","172":"49c149cf","193":"0bcbeb7b","282":"407cea66","310":"420296ac","407":"a170c528","520":"db84bb34","615":"e659b434","720":"d416ba4a","818":"47092452","844":"9999fadd","895":"811b4bbd"}[chunkId] + ".chunk.js";
};